module.exports = __webpack_public_path__ + "img/flop10FilterOff.8d73430e.svg";